import angular from 'angular'

import { makeOR } from '../../utils/bits'
import { uniqueId } from 'lodash-es'

import envRaw from '../../utils/env-raw'
import Emitter from '../../utils/emitter'
import SumEmitter from '../../utils/sum-emitter'
import attachEmitters from '../../utils/attach-emitters'

import Template from './gallery-text.component.ejs'

angular
  .module('ggs.gallery-text')
  .factory('isTextContent', IsTextContentProvider)
  .component('ggsGalleryText', {
    template: Template({
      LE: envRaw.liveEditMode
    }),
    controller: GalleryTextComponent,
    bindings: {
      ggsPost: '<',
      ggsMedia: '<',
      ggsProperties: '<',
      ggsIsTinyLayout: '<',
      ggsContentReadyHandler: '<',
      ggsContentChangeHandler: '<',
      ggsContentAttachCallback: '<'
    }
  })

function IsTextContentProvider() {
  return function isTextContent(media) {
    return media.info.isSomeText
  }
}

const QS_CONTENT = '.ggs-gallery-text'

function GalleryTextComponent(
  qh,
  domh,
  $scope,
  $element,
  fontEmitter,
  DefineMethod,
  DefineHandler,
  AdvancedHeightCache) {

  const $ctrl = $scope.$ctrl = this
  const sign = `galleryText[id=${$ctrl.ggsPost.id}][mi=${$ctrl.ggsMedia.media_index}][uid=${uniqueId()}]`

  $ctrl.wrapM = DefineMethod(sign)
  $ctrl.wrapH = DefineHandler(sign)

  const contentElm = domh.find($element, QS_CONTENT)
  const heightCache = AdvancedHeightCache('galleryText::common', contentElm)

  $ctrl.contentSizeEmitter = Emitter(`${sign}:contentSize`)
  $ctrl.contentSize = {
    width: undefined,
    height: undefined
  }

  $ctrl.isTinyLayout = attachEmitters(
    $ctrl.ggsIsTinyLayout,
    $ctrl.ggsProperties.key2emitter.text_force_tiny,
    makeOR(
      $ctrl.ggsIsTinyLayout,
      $ctrl.ggsProperties.key2get.text_force_tiny))

  $ctrl.isTinyLayoutEmitter = SumEmitter($ctrl.isTinyLayout)

  // $postLink

  $ctrl.wrapH('$postLink', () => {
    fontEmitter.on($ctrl.layoutChangeHandler)
    $ctrl.isTinyLayoutEmitter.on($ctrl.layoutChangeHandler)
    return qh.join(
      $ctrl.ggsContentAttachCallback(
        $ctrl.extContentCalcWidth,
        $ctrl.extContentCalcHeight,
        $ctrl.extContentApplySize),
      $ctrl.ggsContentReadyHandler())
  })

  // $onDestroy

  $ctrl.wrapH('$onDestroy', () => {
    heightCache.destroy()
    fontEmitter.off($ctrl.layoutChangeHandler)
    $ctrl.isTinyLayoutEmitter.off($ctrl.layoutChangeHandler)
  })

  // <ggs-gallery-modal/>

  $ctrl.extContentCalcWidth = (_showcaseHeight) => {
    return null
  }

  $ctrl.extContentCalcHeight = (showcaseWidth) => {
    return heightCache.calc(showcaseWidth)
  }

  $ctrl.wrapM('extContentApplySize', (showcaseSize) => {
    const cntHeight = $ctrl.extContentCalcHeight(showcaseSize.width)

    const height = cntHeight > showcaseSize.height ? showcaseSize.height : null
    const overflowY = cntHeight > showcaseSize.height ? 'auto' : null
    const marginTop = cntHeight < showcaseSize.height ? Math.round((showcaseSize.height - cntHeight) / 2) : null

    $ctrl.contentSize = { height, overflowY, marginTop }
    $ctrl.contentSizeEmitter.emit()
  })

  // handlers

  $ctrl.wrapH('layoutChangeHandler', () => {
    heightCache.clear()
    return $ctrl.ggsContentChangeHandler()
  })
}
